import React, { Fragment } from "react";

import img13 from "../../../images/service/Initial Liquidity Offering/1.png";
import img14 from "../../../images/service/Initial Liquidity Offering/2.png";


import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import Benefit from "../../../components/PageSection/BenefitSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import HeroSection from "../../../components/PageSection/HeroSection";
import TheorySection from "../../../components/PageSection/Theory";

// --------------------------------------------------
// DATA
// --------------------------------------------------

const serviceCards = [
  {
    icon: sIcon1,
    title: "ILO Platform Development",
    content:
      "Design and development of secure Initial Liquidity Offering platforms with automated liquidity provisioning.",
  },
  {
    icon: sIcon2,
    title: "Liquidity Pool Creation",
    content:
      "Deployment of liquidity pools on decentralized exchanges with optimized pricing mechanisms.",
  },
  {
    icon: sIcon3,
    title: "Smart Contract Engineering",
    content:
      "Audited smart contracts for liquidity locking, vesting, and automated fund allocation.",
  },
];

const benefits = [
  {
    title: "Instant Market Liquidity",
    description:
      "ILO ensures immediate liquidity for newly launched tokens on decentralized exchanges.",
    icon: sIcon1,
  },
  {
    title: "Fair Price Discovery",
    description:
      "Automated market makers enable transparent and demand-driven token pricing.",
    icon: sIcon2,
  },
  {
    title: "Investor Confidence",
    description:
      "Locked liquidity and transparent fund usage reduce rug-pull risks.",
    icon: sIcon3,
  },
  {
    title: "Decentralized Fundraising",
    description:
      "Funds are raised and distributed without centralized intermediaries.",
    icon: sIcon4,
  },
  {
    title: "Community Participation",
    description:
      "Users actively contribute liquidity and become part of the ecosystem.",
    icon: sIcon5,
  },
  {
    title: "Exchange Readiness",
    description:
      "Projects gain immediate access to DEX trading environments.",
    icon: sIcon6,
  },
];

const faqs = [
  {
    q: "What is an Initial Liquidity Offering (ILO)?",
    a: "An Initial Liquidity Offering is a fundraising model where token liquidity is provided directly on decentralized exchanges at launch.",
  },
  {
    q: "How is ILO different from ICO or IDO?",
    a: "Unlike ICOs or IDOs, ILOs prioritize liquidity provisioning and price stability from day one.",
  },
  {
    q: "Which platforms support ILO launches?",
    a: "ILOs are commonly launched on DEX platforms such as Uniswap, PancakeSwap, and other AMM-based exchanges.",
  },
  {
    q: "Do you provide liquidity locking?",
    a: "Yes. We implement liquidity locking mechanisms to enhance trust and security.",
  },
];

// --------------------------------------------------
// PAGE COMPONENT
// --------------------------------------------------

export default function InitialLiquidityOffering() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Initial Liquidity Offering (ILO)"
        pagesub="Launch your token with built-in liquidity and trust"
      />

      {/* ================= HERO ================= */}
      <HeroSection
        title={
          <>
            Launch Tokens with Confidence via{" "}
            <span className="gradient-text">Initial Liquidity Offering</span>
          </>
        }
        subtitle={`Initial Liquidity Offerings enable projects to launch tokens with
immediate market liquidity on decentralized exchanges. We help you
design, deploy, and manage secure ILO platforms for transparent token launches.`}
        buttonText="Launch Your ILO"
        buttonLink="/contact"
        image={img13}
        imageAlt="Initial Liquidity Offering Development"
      />

      {/* ================= THEORY SECTION 1 ================= */}
      <TheorySection
        title="What Is an Initial Liquidity Offering?"
        image={img14}
        paragraphs={[
          "An Initial Liquidity Offering (ILO) is a decentralized fundraising mechanism designed to provide immediate liquidity for newly launched crypto tokens. Instead of selling tokens directly to investors, projects allocate raised funds to liquidity pools on decentralized exchanges, ensuring instant tradability and transparent price discovery from the moment of launch.",
          "By leveraging automated market maker (AMM) protocols, ILOs eliminate centralized control over token pricing and distribution. This model enhances trust, reduces market manipulation, and creates a more sustainable trading environment for early investors and community participants.",
        ]}
      />

      

      {/* ================= SERVICES ================= */}
      <ServiceCardsSection
        title="Our Initial Liquidity Offering Services"
        cards={serviceCards}
      />

      {/* ================= THEORY SECTION 2 ================= */}
      <TheorySection
        title="Why ILOs Are Gaining Popularity"
        image={img13}
        paragraphs={[
          "Traditional token launches often struggle with liquidity shortages and volatile price movements. ILOs solve this challenge by embedding liquidity directly into the launch process, allowing tokens to be traded seamlessly without reliance on centralized exchanges.",
          "For startups and Web3 projects, ILOs provide a balanced approach to fundraising and market entry. Investors gain immediate access to tradable assets, while projects benefit from transparent liquidity management, reduced risk of manipulation, and stronger community trust.",
        ]}
      />

      {/* ================= BENEFITS ================= */}
      <Benefit
        title="Benefits of Initial Liquidity Offering"
        benefits={benefits}
      />

      {/* ================= KEY FEATURES ================= */}
      <KeyFeaturesSection
        title="Key Features of ILO Platforms"
        subtitle="A decentralized, secure, and liquidity-driven token launch framework."
        features={[
          {
            icon: sIcon1,
            title: "Automated Liquidity Pools",
            description:
              "Smart contract-driven liquidity provisioning on decentralized exchanges.",
          },
          {
            icon: sIcon2,
            title: "Liquidity Locking",
            description:
              "Lock liquidity for a predefined period to protect investors.",
          },
          {
            icon: sIcon3,
            title: "Fair Launch Mechanism",
            description:
              "Equal access and transparent pricing for all participants.",
          },
          {
            icon: sIcon4,
            title: "Multi-Chain Support",
            description:
              "Launch ILOs across Ethereum, BSC, Polygon, and other networks.",
          },
          {
            icon: sIcon5,
            title: "Security & Audits",
            description:
              "Audited smart contracts to ensure platform reliability.",
          },
          {
            icon: sIcon6,
            title: "Scalable Architecture",
            description:
              "Built to handle high traffic during token launch events.",
          },
        ]}
      />

      {/* ================= WHY CHOOSE US ================= */}
      <WhyChooseUsSection
        items={[
          "Expertise in DeFi & Liquidity Protocols",
          "Secure & Audited Smart Contracts",
          "End-to-End ILO Launch Support",
        ]}
      />

      {/* ================= FAQ ================= */}
      <FaqSection faqs={faqs} />

      {/* ================= CTA ================= */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
